<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div [formGroup]="parentGroup" class="offset-md-3">
  <fieldset>
    <div formGroupName="contacts">
      <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
        <label class="col-sm-8 control-label"> First Name </label>
        <div class="col-md-8">
          <input
            class="form-control"
            type="text"
            name="primaryContactFirstName"
            id="primaryContactFirstNameEdit"
            formControlName="primaryContactFirstName"
            [ngClass]="{
              'is-invalid':
                customerContactFormControl.primaryContactFirstName?.invalid &&
                (customerContactFormControl.primaryContactFirstName?.dirty ||
                  customerContactFormControl.primaryContactFirstName?.touched)
            }"
          />
          <div
            class="formValidationMessage"
            role="alert"
            *ngIf="
              customerContactFormControl.primaryContactFirstName.invalid &&
              (customerContactFormControl.primaryContactFirstName?.dirty ||
                customerContactFormControl.primaryContactFirstName?.touched)
            "
          >
            <div
              class="mt-1"
              *ngIf="
                customerContactFormControl.primaryContactFirstName.errors
                  ?.required
              "
            >
              Field is required.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
        <label class="col-sm-8 control-label"> Last Name </label>
        <div class="col-md-8">
          <input
            class="form-control"
            type="text"
            formControlName="primaryContactLastName"
            id="primaryContactLastNameEdit"
            [ngClass]="{
              'is-invalid':
                customerContactFormControl.primaryContactLastName?.invalid &&
                (customerContactFormControl.primaryContactLastName?.dirty ||
                  customerContactFormControl.primaryContactLastName?.touched)
            }"
          />
          <div
            class="formValidationMessage"
            role="alert"
            *ngIf="
              customerContactFormControl.primaryContactLastName?.invalid &&
              (customerContactFormControl.primaryContactLastName?.dirty ||
                customerContactFormControl.primaryContactLastName?.touched)
            "
          >
            <div
              class="mt-1"
              *ngIf="
                customerContactFormControl.primaryContactLastName.errors
                  ?.required
              "
            >
              Field is required.
            </div>
          </div>
        </div>
      </div>
      <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
        <label class="col-sm-8 control-label"> Email </label>
        <div class="col-md-8">
          <input
            class="form-control"
            type="email"
            formControlName="primaryContactEmail"
            id="primaryContactEmailEdit"
            [ngClass]="{
              'is-invalid':
                customerContactFormControl.primaryContactEmail?.invalid &&
                (customerContactFormControl.primaryContactEmail?.dirty ||
                  customerContactFormControl.primaryContactEmail?.touched)
            }"
          />
          <div
            class="formValidationMessage"
            role="alert"
            *ngIf="
              customerContactFormControl.primaryContactEmail?.invalid &&
              (customerContactFormControl.primaryContactEmail?.dirty ||
                customerContactFormControl.primaryContactEmail?.touched)
            "
          >
            <div class="mt-1">
              <div
                *ngIf="
                  customerContactFormControl.primaryContactEmail.errors?.email
                "
              >
                Please enter a valid email address
              </div>
              <div
                *ngIf="
                  customerContactFormControl.primaryContactEmail.errors
                    ?.required
                "
              >
                Field is required.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group" [ngClass]="{ fieldIsRequired: isWorldPay() }">
        <label class="col-sm-8 control-label"> Phone Number </label>
        <div class="col-md-8">
          <input
            class="form-control"
            type="text"
            formControlName="primaryContactPhoneNumber"
            [ngClass]="{
              'is-invalid':
                customerContactFormControl.primaryContactPhoneNumber?.invalid &&
                (customerContactFormControl.primaryContactPhoneNumber?.dirty ||
                  customerContactFormControl.primaryContactPhoneNumber?.touched)
            }"
          />
          <div
            class="formValidationMessage"
            role="alert"
            *ngIf="
              customerContactFormControl.primaryContactPhoneNumber?.invalid &&
              (customerContactFormControl.primaryContactPhoneNumber?.dirty ||
                customerContactFormControl.primaryContactPhoneNumber?.touched)
            "
          >
            <div class="mt-1">
              <div
                *ngIf="
                  customerContactFormControl.primaryContactPhoneNumber.errors
                    ?.pattern
                "
              >
                Phone number must be 10 digits.
              </div>
              <div
                *ngIf="
                  customerContactFormControl.primaryContactPhoneNumber.errors
                    ?.required
                "
              >
                Field is required.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</div>
